import { createContext, useEffect, useState } from 'react';

import * as T from 'prop-types';

import { ALERT_INITIAL_STATE } from '../components/alert/constants';

const AlertContext = createContext();

const AlertProvider = ({ children }) => {
  const [alert, setAlert] = useState(ALERT_INITIAL_STATE);

  useEffect(() => {
    let timer;
    if (alert.show) {
      timer = setTimeout(() => {
        setAlert(ALERT_INITIAL_STATE);
      }, alert.duration || 3000);
    }
    return () => clearTimeout(timer);
  }, [alert]);

  return <AlertContext.Provider value={{ alert, setAlert }}>{children}</AlertContext.Provider>;
};

AlertProvider.propTypes = {
  children: T.node.isRequired,
};

export default AlertProvider;
export { AlertContext };
